export enum SubmissionType {
    NewBusiness = 'NewBusiness',
    Renewal = 'Renewal',
    BOR = 'BOR',
}
